"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONFIG = void 0;
/**
 * Default configuration for the plugin.
 */
exports.DEFAULT_CONFIG = {
    enabled: true,
    debug: false,
    trackOnNextTick: false,
    loadScript: true,
    defer: false,
    compatibility: false,
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-gtm/dist/config.js
// module id = 711
// module chunks = 0